module.exports = __webpack_public_path__ + "static/media/icon-twitter.e2af5e1b.svg";